import 'react-app-polyfill/ie9';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './css/main.css';

/* components includes */
import App from './components/App';

/* Redux includes */
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';
import thunk from 'redux-thunk';
import persist from './middleware/Persist';
import reducers from './reducers';
import { initLang } from './helpers';
import {
  localStorageAuthToken,
  localStorageProfileName,
  localStorageLang,
  localStorageProfileId,
  localStorageIsChild,
} from './constants';
import {
  AUTH_USER,
  PROFILE_NAME,
  SWITCH_LANGUAGE,
  PROFILE_ID,
  PROFILE_IS_CHILD,
} from './actions/types';

import { createRoot } from 'react-dom/client';

if (process.env.NODE_ENV !== 'production') {
  var axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}
const createStoreWithMiddleware = applyMiddleware(
  ReduxPromise,
  thunk,
  persist
)(createStore);
const store = createStoreWithMiddleware(reducers);

let token = localStorage.getItem(localStorageAuthToken);
if (token) {
  store.dispatch({ type: AUTH_USER, payload: token });
}

if (localStorage.getItem(localStorageProfileName)) {
  store.dispatch({
    type: PROFILE_NAME,
    payload: localStorage.getItem(localStorageProfileName),
  });
}

if (localStorage.getItem(localStorageProfileId)) {
  store.dispatch({
    type: PROFILE_ID,
    payload: localStorage.getItem(localStorageProfileId),
  });
}

if (localStorage.getItem(localStorageIsChild)) {
  store.dispatch({
    type: PROFILE_IS_CHILD,
    payload: localStorage.getItem(localStorageIsChild),
  });
}

initLang();
if (localStorage.getItem(localStorageLang)) {
  store.dispatch({
    type: SWITCH_LANGUAGE,
    payload: parseInt(localStorage.getItem(localStorageLang), 10),
  });
}

/*ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);*/

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Provider store={store}><App tab="home" /></Provider>);
